import * as Switch from '@radix-ui/react-switch';
import React from 'react';

interface Props {
  checked: boolean;
  disabled?: boolean;
  label?: string;
  onCheckedChange: (checked: boolean) => void;
}

export const Toggle: React.FC<Props> = ({
  checked,
  disabled,
  label,
  onCheckedChange,
}) => (
  <Switch.Root
    checked={checked}
    disabled={disabled}
    aria-label={label}
    onCheckedChange={onCheckedChange}
    className="relative inline-flex h-[31px] w-[52px] shrink-0 cursor-pointer items-center rounded-full outline-none transition-colors data-[state=unchecked]:bg-info-surface data-[state=checked]:bg-primary data-[disabled]:cursor-not-allowed data-[state=unchecked]:data-[disabled]:bg-on-primary-surface data-[disabled]:data-[state=checked]:opacity-30"
  >
    <Switch.Thumb className="block size-[31px] rounded-full border-[2px] border-info-surface bg-white transition-transform duration-150 ease-out will-change-transform data-[state=checked]:translate-x-[21px] data-[state=checked]:border-primary" />
  </Switch.Root>
);
